import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { Price } from '@zapier/currency';
import { buildUpgradeUrl } from './utils';
export const shouldRender = (data) => {
    const { currentAccount } = data;
    return (currentAccount.isTrialingCompanies &&
        currentAccount.companiesTrialEndDate &&
        ['owner', 'admin'].includes(currentAccount.currentUserRole));
};
export const Component = function CompaniesTrialing(props) {
    var _a, _b;
    const { data, currency } = props;
    const { currentAccount } = data;
    const { companiesTrialEndDate } = currentAccount;
    const trialDaysRemaining = daysFromNow(companiesTrialEndDate);
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const title = `${trialDaysRemaining} ${daysText} left in your Company trial`;
    const nextPlanAmount = (((_a = data.nextCompanyPlan) === null || _a === void 0 ? void 0 : _a.amount) || 0) / 12;
    const upgradeUrl = buildUpgradeUrl({
        currentPlanName: currentAccount.plan.name,
        upgradePlanName: (_b = data.nextCompanyPlan) === null || _b === void 0 ? void 0 : _b.name,
        interval: currentAccount.plan.interval,
    });
    const onUpgrade = () => {
        props.trackEvent('Trial: clicked upgrade from Company trial banner');
    };
    const onRequestDemo = () => {
        props.trackEvent('company-trial-guide', {
            accountId: currentAccount.id,
            profileId: data.currentUser.id,
            isOwner: currentAccount.currentUserRole === 'owner',
        });
    };
    return (isolateComponent(Alert, { layout: props.layout, title: title, type: "info" },
        isolateComponent(Link, { href: upgradeUrl, onClick: onUpgrade }, "Upgrade"),
        ' ',
        "anytime for as low as ",
        isolateComponent(Price, { currency: currency }, nextPlanAmount),
        "/month. ",
        'Have questions about the Company plan? ',
        isolateComponent(Link, { href: "/app/company-account-setup/getting-started", onClick: onRequestDemo }, "Request a demo")));
};
//# sourceMappingURL=CompaniesTrialing.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
